export default __webpack_public_path__ + "dist/media/icons.e3d8f25c.svg";